export default __webpack_public_path__ + "static/media/1.1d8eb2f5.jpg";